export function ExpandAll({ className = '' }: Readonly<{ className?: string }>) {
  return (
    <span className={`icon ${className}`}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 16 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M11.2638 14.6067L8.32385 11.6667C8.29052 11.6334 8.25052 11.6 8.20385 11.58C8.15718 11.56 8.11052 11.5534 8.05718 11.5534C8.00385 11.5534 7.95718 11.5667 7.91052 11.58C7.86385 11.6 7.82385 11.6267 7.79052 11.6667L4.85052 14.6067M1.33331 8.00004H14.6666M11.2066 1.33337L8.26661 4.27337C8.23327 4.30671 8.19327 4.34004 8.14661 4.36004C8.09994 4.38004 8.05327 4.38671 7.99994 4.38671C7.94661 4.38671 7.89994 4.37338 7.85328 4.36004C7.80661 4.34004 7.76661 4.31337 7.73327 4.27337L4.79327 1.33337"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </span>
  );
}
